import { RequestService } from '../../../../common/services/RequestService';
import { adjustTemplatesData } from './adjustTemplatesData';
import { GET_ALL_TEMPLATES } from '../constants';

export const getAllTemplatesRequest = async profileId => {
  const response = await RequestService.get(
    GET_ALL_TEMPLATES.replace('{profile_id}', profileId)
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(order => adjustTemplatesData(order))
  );
};
